import logo from './logo.svg';
import './App.css';
import Dashboard from './dashboard/Dashboard';

function App() {
  return (
    <div>
      <Dashboard />
    </div>
  );
}

export default App;
